import styled from 'styled-components';

export const StyledIconContainer = styled.div`
    ${({ theme }) => `
        width: 26px;
        height: 26px;

        border-radius: 50%;
        
        background-color: ${theme.palette.common.dimBlue};

        display: flex;
        align-items: center;
        justify-content: center;
    `}
`;

export const StyledInfoContainer = styled.div`
    ${() => `
        display: flex;
        align-items: center;

        column-gap: 10px;
    `}
`;

export const StyledTextContainer = styled.div`
    ${({ theme }) => `
    margin-bottom: 15px;
    display: inline-block;

    border-radius: 16px;
    box-sizing: border-box;
    border: 1px solid ${theme.palette.common.white};
    box-shadow: -1px 9px 18px rgba(95, 102, 140, 0.06);

    padding: 15px 20px;

    background: ${theme.palette.common.shadeGrayGradient};

    width: 100%;

    & > * {
        margin-bottom: 10px;
    }
    & > *:last-child {
        margin-bottom: 0;
    }
    `}
`;
